import React from 'react';
import { motion } from 'motion/react';
import twMerge from 'utilities/src/twMerge';
import { PARTICLES } from './constants';

export default function WidgetEntranceEffect() {
  return (
    <>
      <motion.span
        aria-hidden
        className="border-site-primary-600/45 pointer-events-none absolute inset-0 z-[-1] rounded-xl border-2"
        initial={{ scale: 0.8, opacity: 0.9 }}
        animate={{ scale: 2.4, opacity: 0, borderWidth: 1 }}
        transition={{ duration: 0.9, delay: 0.16, ease: [0.2, 0.8, 0.2, 1] }}
      />
      <span aria-hidden className="pointer-events-none absolute inset-0">
        {PARTICLES.map(({ dx, dy, light }) => (
          <motion.span
            key={`${dx}-${dy}-${light}`}
            className={twMerge(
              'absolute left-1/2 top-1/2 -m-[3px] size-1.5 [clip-path:polygon(50%_0,62%_38%,100%_50%,62%_62%,50%_100%,38%_62%,0_50%,38%_38%)]',
              light ? 'bg-site-neutrals-0' : 'bg-site-primary-200',
            )}
            initial={{ x: 0, y: 0, scale: 0.2, opacity: 0, rotate: 0 }}
            animate={{ x: dx, y: dy, scale: 1, opacity: [0, 1, 0], rotate: 180 }}
            transition={{ duration: 1, delay: 0.12, ease: [0.2, 0.8, 0.2, 1] }}
          />
        ))}
      </span>
    </>
  );
}
